import { IBudgetRange } from '@share/common-types';

/**
 * When the API returns adjacent $400–$500 and “$500+” buckets, splits them into
 * $400–$499, $500 (exact), and 500+ (from $500) so the slider can expose a
 * dedicated $500 tier and a final 500+ tier.
 */
export function normalizeActivityBudgetRanges(ranges: IBudgetRange[]): IBudgetRange[] {
  if (!ranges?.length) return ranges;

  const has500Exact = ranges.some((r) => r.key.from === 500 && r.key.to === 500);
  if (has500Exact) return ranges;

  const sorted = [...ranges].sort((a, b) => {
    const af = a.key.from ?? -Infinity;
    const bf = b.key.from ?? -Infinity;
    if (af !== bf) return af - bf;
    const at = a.key.to ?? Infinity;
    const bt = b.key.to ?? Infinity;
    return at - bt;
  });

  const out: IBudgetRange[] = [];

  for (let i = 0; i < sorted.length; i++) {
    const r = sorted[i];
    const next = sorted[i + 1];
    const is400_500 = r.key.from === 400 && r.key.to === 500;
    const is500_open = next && next.key.from === 500 && next.key.to == null;

    if (is400_500 && is500_open) {
      out.push({ ...r, key: { from: 400, to: 499 } });
      out.push({ key: { from: 500, to: 500 }, count: 0 });
      out.push({ ...next, key: { from: 500, to: null } });
      i += 1;
      continue;
    }

    out.push(r);
  }

  return out;
}

/** Legacy keys from filters / URL before we split the top buckets */
export const ACTIVITY_BUDGET_KEY_ALIASES: Record<string, string> = {
  '400-500': '400-499',
  '500-null': '500-null',
};
